export const RED_FROG_ID = process.env.REACT_APP_REDFROG_ASSET_ID;
export const DETOX_ID = process.env.REACT_APP_DETOX_ASSET_ID;
export const LDB_ID = process.env.REACT_APP_LDB_ASSET_ID;
export const AIRBC_ID = process.env.REACT_APP_AIRBC_ASSET_ID;